import React, { Component } from 'react';
import FAQComponent from '../components/faqComponent';
import {getAllFAQList, addFaq,
    deleteFAQData, updateFaq, updateFAQSequence } from '../action/faqAction';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';

export class FAQContainer extends Component{
    constructor(props){
        super(props)
    }
    componentDidMount(){
        this.props.actions.getAllFAQList();
    }
    getFAQListData = () =>{
        this.props.actions.getAllFAQList(
            this.props.dispatch
        )
    }
    updateFAQ = (formData) =>{
        this.props.actions.updateFaq(
            formData,
            this.props.dispatch
        )
    }
    saveSequenceList = (array) =>{
        this.props.actions.updateFAQSequence(
            array,
            this.props.dispatch
        )
    }
    addFAQFunc = (formData) =>{
        this.props.actions.addFaq(
            formData,
            this.props.dispatch
        )
    }
    deleteFAQItem = (payload) => {
        this.props.actions.deleteFAQData(
            payload,
            this.props.dispatch
        )
    }
    render(){
        return(
            <div>
                <FAQComponent
                    FAQDetails = {this.props.FAQData}
                    addFAQ = {this.addFAQFunc}
                    deleteFAQItem = {this.deleteFAQItem}
                    getFAQListData ={this.getFAQListData}
                    updateFAQ = {this.updateFAQ}
                    saveSequenceList = {this.saveSequenceList}
                >
                </FAQComponent>
            </div>
        )
    }
}
function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getAllFAQList,
            addFaq,
            deleteFAQData,
            updateFaq,
            updateFAQSequence
        },
            dispatch)
    };
}
function mapStateToProps({ FAQReducer }) {
    console.log(FAQReducer);
    return {
        FAQData : {
            errorCode : FAQReducer.errorCode,
            statusCode : FAQReducer.statusCode,
            FAQList : FAQReducer.FAQList,
            message : FAQReducer.message,
            isLoading : FAQReducer.isLoading
        }
    }
}
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(FAQContainer));